


















































/* General */

/* Mixins */
import entityTypeMixin from '@/mixins/entity-type.mixin'

/* Components */
import DashboardTableView from './dashboard-table-view.vue'
import DashboardCardEntity from './dashboard-card-entity.vue'
import DashboardEntitiesEmpty from './dashboard-entities-empty.vue'
import DashboardEntitiesNoResults from './dashboard-entities-no-results.vue'

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import AppSumoAssistant from '@/helpers/appsumo-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogsDailyActivityLog,
} from '@/api/types/response.types'

/* API */

export default entityTypeMixin.extend({
  name: 'DashboardEntitiesView',

  components: {
    DashboardTableView,
    DashboardCardEntity,
    DashboardEntitiesEmpty,
    DashboardEntitiesNoResults,
  },

  props: {
    /**
     * View Type: Grid or Table
     */
    viewType: {
      type: String,
      required: true,
    },
    entities: {
      type: Array as () => Array<IProjectsOutputProjectForHome>,
      required: true,
    },
    dailyActivityLogs: {
      type: Array as () => Array<IProjectDailyActivityLogsDailyActivityLog>,
      default: null,
    },
    profile: {
      type: Object,
      required: true,
    },
    isSearching: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      AppSumoAssistant,
      TextAssistant,
    }
  },

  computed: {
    // Order by favorites first, then sorted...
    orderedEntities(): IProjectsOutputProjectForHome[] {
      return this.entities.sort((a, b) => {
        const aIsSample = this.$permissions.isSampleInternalProjectID(a.id)
        const bIsSample = this.$permissions.isSampleInternalProjectID(b.id)

        /* Favorites first */
        if (a.isFavorite && !b.isFavorite) {
          return -1
        }
        if (!a.isFavorite && b.isFavorite) {
          return 1
        }

        /* Samples second */
        if (aIsSample && !bIsSample) {
          return -1
        }
        if (!aIsSample && bIsSample) {
          return 1
        }

        /* Alphabetical third */
        return a.name > b.name ? 1 : -1
      })
    },
    noSearchResults(): boolean {
      return this.entities.length === 0 && this.isSearching
    },
    noEntities(): boolean {
      return this.entities.length === 0 && !this.isSearching
    },
    entitiesExist(): boolean {
      return !this.noEntities && !this.noSearchResults
    },
    showGrid(): boolean {
      return this.viewType === 'grid'
    },
    showTable(): boolean {
      return this.viewType === 'table'
    },
  },

  methods: {
    getDailyActivityLog(entity: IProjectsOutputProjectForHome) {
      if (this.dailyActivityLogs === null) {
        return null
      }
      return this.dailyActivityLogs.find(d => d.id === entity.id)
    },
  },
})
